/**
 * @author rmh
 * 模块说明：回告异常
 */
import { Service } from '@/tools'

export class ProcureReturnableQueryServer<T extends TProcure.returnableQuery> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.returnableQuery}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // /**
  //  * 模块说明：列表相关接口
  //  */
  // reportReturnPage = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']['data']> => {
  //   return this.post2('v1/ApiPage', data)
  // }
  /**
   * 模块说明：分页查询
   * /api/procure/allow/return/commodity/v1/page
   */
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明：可退查询导入
   *  /api/procure/allow/return/commodity/v1/importExcel
   */
  importExcel = <K extends T['ApiImportExcel']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiImportExcel', data)
  }

  /**
   * 模块说明：提交退货申请单
   * /api/procure/allow/return/commodity/v1/submitReturnApply
   */
  submitReturnApply = <K extends T['ApiSubmitReturnApply']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiSubmitReturnApply', data)
  }
}
